import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api, { BASE as API_BASE } from '../services/api';

export default function AdView() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const res = await api.getAdVideo(id);
        if (res?.error || !res?.item) throw new Error(res?.error || 'Not found');
        if (alive) setItem(res.item);
      } catch (e) {
        setErr(e.message || 'Failed to load');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [id]);

  if (loading) return <div style={{ padding: 24 }}>Loading…</div>;
  if (err || !item) return <div style={{ padding: 24, color: '#fca5a5' }}>{err || 'Not found'}</div>;

  const vsrc = item.videoUrl?.startsWith('/uploads/') ? `${API_BASE}${item.videoUrl}` : item.videoUrl;
  const poster = item.thumbnailUrl?.startsWith?.('/uploads/') ? `${API_BASE}${item.thumbnailUrl}` : item.thumbnailUrl;

  return (
    <div style={{ padding: 24 }}>
      <div style={{ marginBottom: 12 }}>
        <Link to="/discover" style={{ color: '#60a5fa' }}>← Back</Link>
      </div>
      <div style={{ background: '#111827', border: '1px solid #374151', borderRadius: 12, padding: 16 }}>
        <h2 style={{ color: '#ff7a45', marginTop: 0 }}>{item.title || 'Ad Video'}</h2>
        <div style={{ color: '#9ca3af', marginBottom: 12 }}>
          {item.createdAt ? new Date(item.createdAt).toLocaleString() : ''}
        </div>
        <video
          src={vsrc}
          poster={poster || undefined}
          controls
          preload="metadata"
          style={{ width: '100%', maxWidth: 720, borderRadius: 8, border: '1px solid #374151' }}
        />
        <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
          <button
            onClick={() => { try { navigator.clipboard.writeText(window.location.href); } catch {} }}
            style={{ padding: '6px 10px', background: '#374151', color: '#e5e7eb', borderRadius: 8 }}
          >Share</button>
          {vsrc && (
            <a href={vsrc} download style={{ color: '#93c5fd' }}>Download</a>
          )}
        </div>
      </div>
    </div>
  );
}
